// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IHealthPlanEnrollmentBriefDto
 */
export interface IHealthPlanEnrollmentBriefDto {
    /**
     * 
     * @type {number}
     * @memberof IHealthPlanEnrollmentBriefDto
     */
    enrolled_in_health_plans_count?: number;
}

/**
 * Check if a given object implements the IHealthPlanEnrollmentBriefDto interface.
 */
export function instanceOfIHealthPlanEnrollmentBriefDto(value: object): value is IHealthPlanEnrollmentBriefDto {
    return true;
}

export function IHealthPlanEnrollmentBriefDtoFromJSON(json: any): IHealthPlanEnrollmentBriefDto {
    return IHealthPlanEnrollmentBriefDtoFromJSONTyped(json, false);
}

export function IHealthPlanEnrollmentBriefDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IHealthPlanEnrollmentBriefDto {
    if (json == null) {
        return json;
    }
    return {
        
        'enrolled_in_health_plans_count': json['enrolled_in_health_plans_count'] == null ? undefined : json['enrolled_in_health_plans_count'],
    };
}

export function IHealthPlanEnrollmentBriefDtoToJSON(json: any): IHealthPlanEnrollmentBriefDto {
    return IHealthPlanEnrollmentBriefDtoToJSONTyped(json, false);
}

export function IHealthPlanEnrollmentBriefDtoToJSONTyped(value?: IHealthPlanEnrollmentBriefDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enrolled_in_health_plans_count': value['enrolled_in_health_plans_count'],
    };
}

